import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'DESPESA_PLACA_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}

export function setAguardando(aguardando) {
    return {
        type: 'DESPESA_PLACA_SET_AGUARDANDO',
        payload: aguardando
    };
}

export function initForm(registro = {}) {
    return [
        initialize('despesaPlacaForm', registro)
    ];
}

export function getLista(dataInicial, dataFinal) {
	return (dispatch, getState) => {
		
		dispatch(setAguardando(true));

		axios.get(`${consts.API_URL}/despesaPlaca?data_inicial=${dataInicial}&data_final=${dataFinal}`).then(resp => {
			dispatch({
				type: 'DESPESA_PLACA_LISTADO',
				payload: resp
			});
			dispatch(setAguardando(false));
		}).catch(e => {
			setErroAPI(e);
			dispatch(setAguardando(false));
		});
	};
}

export function salvar(registro) {
    return (dispatch, getState) => {
		if (!registro.id) {
	        axios.post(`${consts.API_URL}/despesaPlaca`, {
				...registro,
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		} else {
			axios.put(`${consts.API_URL}/despesaPlaca`, {
				...registro,				
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		}
    };
}

export function excluir(registro) {
    return (dispatch, getState) => {
        axios.delete(`${consts.API_URL}/despesaPlaca?id=${registro.id}&id_usuario_alteracao=${getState().auth.usuario.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}

export function getListaTipo() {
    const request = axios.get(`${consts.API_URL}/despesaPlaca/listarTipoSelect`);
    return {
        type: 'DESPESA_PLACA_TIPO_SELECT_LISTADO',
        payload: request
    };
}

export function getListaItem() {
    const request = axios.get(`${consts.API_URL}/despesaPlaca/listarItemSelect`);
    return {
        type: 'DESPESA_PLACA_ITEM_SELECT_LISTADO',
        payload: request
    };
}

export function getListaVeiculo() {
    const request = axios.get(`${consts.API_URL}/veiculo/listarSelect`);
    return {
        type: 'DESPESA_PLACA_VEICULO_SELECT_LISTADO',
        payload: request
    };
}

export function getListaUnidade() {
    const request = axios.get(`${consts.API_URL}/unidade/listarSelect`);
    return {
        type: 'DESPESA_PLACA_UNIDADE_SELECT_LISTADO',
        payload: request
    };
}

export function importarCusto(tabela1, tabela2) {
    return async (dispatch, getState) => {

		dispatch(setAguardando(true));

		const listaTabela1 = tabela1 ? tabela1.lista : [];
		const listaTabela2 = tabela2 ? tabela2.lista : [];

		let lista = [];

		for (var i = 0; i < listaTabela1.length; i++) {
			let item = listaTabela1[i];

			const registro = {
				data_despesa: `${item[2].split('/')[2]}/${item[2].split('/')[1].padStart(2, '0')}/${item[2].split('/')[0].padStart(2, '0')}`,
				tipo: item[0],
				placa: converterPlacaMercosul(item[3]),
				estabelecimento: item[1],
				pessoa: item[4],
				codigo_item: item[5],
				nome_item: item[6],
				valor: item[9]
			};

			if (registro.data_despesa && registro.placa && registro.valor 
				&& !(registro.tipo || '').toUpperCase().includes('ABASTECIMENTO')
				&& !(registro.pessoa || '').toUpperCase().includes('IPVA')
			) {
				lista.push(registro);
			}
			
		}

		for (var i = 0; i < listaTabela2.length; i++) {
			let item = listaTabela2[i];
			
			const registro = {
				data_despesa: `${item[2].split('/')[2]}/${item[2].split('/')[1].padStart(2, '0')}/${item[2].split('/')[0].padStart(2, '0')}`,
				tipo: item[0],
				placa: converterPlacaMercosul(item[3]),
				estabelecimento: item[1],
				pessoa: item[4],
				codigo_item: item[5],
				nome_item: null,
				valor: item[7]
			};

			if (registro.data_despesa && registro.placa && registro.valor && !(registro.tipo || '').toUpperCase().includes('ABASTECIMENTO')) {
				lista.push(registro);
			}
			
		}

		await axios.post(`${consts.API_URL}/despesaPlaca`, {
			lista: lista
		}).then(resp => {
			console.log('Operação Realizada com sucesso.');
		}).catch(e => {
			// console.log(e);
			// console.log(registro);
		});

		setSuccess('Importação Realizada com sucesso.');
		// dispatch(getLista());
		dispatch(setAguardando(false));

    };
}

function converterPlacaMercosul(texto) {

    const placaEncontrada = (texto || '')
        .toUpperCase()
        .match(/[A-Z]{3}[0-9][A-Z0-9][0-9]{2}/);

    if (!placaEncontrada) {
        return null;
    }

    let placa = placaEncontrada[0];

    // Já está no padrão Mercosul
    if (/^[A-Z]{3}[0-9][A-Z][0-9]{2}$/.test(placa)) {
        return placa;
    }

    // Padrão antigo ABC1234
    if (/^[A-Z]{3}[0-9]{4}$/.test(placa)) {

        const mapa = {
            '0': 'A',
            '1': 'B',
            '2': 'C',
            '3': 'D',
            '4': 'E',
            '5': 'F',
            '6': 'G',
            '7': 'H',
            '8': 'I',
            '9': 'J'
        };

        placa =
            placa.substring(0, 3) +
            placa.substring(3, 4) +
            mapa[placa.substring(4, 5)] +
            placa.substring(5);
    }

    return placa;
}

export function importarFolha(tabela) {
    return async (dispatch, getState) => {

		dispatch(setAguardando(true));
		
		const listaTabela = tabela ? tabela.lista : [];

		let lista = [];

		for (var i = 0; i < listaTabela.length; i++) {
			let item = listaTabela[i];

			let data = item[8];

			if (data) {
				
				data.setHours(data.getHours() + 12);

				const registro = {
					data_custo: `${data.getFullYear()}/${String(data.getMonth() + 1).padStart(2, '0')}/${String(data.getDate()).padStart(2, '0')}`,
					pessoa: (item[3] || '').replace('Historico: ADTO SALARIO', '').replace('Historico: MENSAL', '').replace('Historico: FERIAS', '').trim(),
					descricao: item[4],
					valor: item[27]
				};

				if (registro.data_custo && registro.pessoa && registro.valor) {
					lista.push(registro);
				}
			}	
		}
		
		await axios.post(`${consts.API_URL}/custoFolhaPessoaMes`, {
			lista: lista
		}).then(resp => {
			console.log('Operação Realizada com sucesso.');
		}).catch(e => {
			// console.log(e);
			// console.log(registro);
		});		

		setSuccess('Importação Realizada com sucesso.');
		// dispatch(getLista());
		dispatch(setAguardando(false));

    };
}